<template>
  <div class="top_content" :style="{ color: `${colorData}` }">
    <span>本系统是预报名，由主办方基金会最终审核和决定参与人选</span>
    <el-button v-if="status" class="outlogin" @click="outLogin"
      >退出登录</el-button
    >
  </div>
</template>

<script >
export default {
  props: {
    colorData: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    outLogin() {
      this.$confirm("此操作将确认退出报名系统, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass",
        cancelButtonClass: "cancelButtonClass",
        type: "error",
      })
        .then(() => {
          this.$router.push({
            path: "/reportLogin",
          });
        })
        .catch(() => {});

      // let msg = {
      //   title: "温馨提示",
      //   html: `<div class="popup-content-main">确认退出报名系统</div>`,
      //   btngroup: { sure: "确认退出", close: "取消" },
      //   align: "center",
      // };

      // PopopInstance(msg).then(() => {
      //   this.$router.push({
      //     path: "/reportLogin",
      //   });
      // });
    },
  },
};
</script>

<style >
.top_content {
  font-size: 0.625rem;
  text-align: center;
  position: relative;
}
.top_content .outlogin {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  color: #fff;
}
.el-overlay .cancelButtonClass {
  background: #fff;
}
</style>